import { Middleware } from '@nuxt/types';

import { IRouteInfo } from '~/types/IRouteInfo';

const sectionSeo: Middleware = async ({ store }) => {
  const routeInfo: IRouteInfo = store.getters['szukaj/routeInfo'];

  if (routeInfo.Seo && routeInfo.Klucz !== 'szukaj') {
    try {
      await store.dispatch('szukaj/ustawSekcjeSeo', routeInfo);
    } catch (error) {
      /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
      console.error('🔥🔥 ERROR IN MIDDLEWARE/SECTION-SEO.TS 🔥🔥');
      console.error(error);
      store.commit('szukaj/wyczyscSekcjeSeo');
    }
  } else {
    store.commit('szukaj/wyczyscSekcjeSeo');
  }
};

export default sectionSeo;
